export function toHref(url) {
  if (!url) return "#";
  const u = url.trim();
  return /^https?:\/\//i.test(u) ? u : `https://${u}`;
}

export function detectSocial(url) {
  const u = (url || "").toLowerCase();
  if (u.includes("linkedin")) return { key: "linkedin", label: "LinkedIn" };
  if (u.includes("twitter") || u.includes("x.com")) return { key: "twitter", label: "X (Twitter)" };
  if (u.includes("instagram")) return { key: "instagram", label: "Instagram" };
  if (u.includes("facebook") || u.includes("fb.com")) return { key: "facebook", label: "Facebook" };
  if (u.includes("github")) return { key: "github", label: "GitHub" };
  if (u.includes("youtube") || u.includes("youtu.be")) return { key: "youtube", label: "YouTube" };
  if (u.includes("tiktok")) return { key: "tiktok", label: "TikTok" };
  return { key: "link", label: "Link" };
}
